import React, { useState, useEffect } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Badge } from 'reactstrap';
import CitiesServices from "services/Admin/CitiesService"
import { Link } from "react-router-dom";
import DeleteModal from "components/Common/DeleteModal"
import AvField from "availity-reactstrap-validation/lib/AvField";
import AvForm from "availity-reactstrap-validation/lib/AvForm";
import { SuccessOk } from 'configs/statusCode';
import { toast } from 'react-toastify';
import { providerPrefix } from 'configs/routePrefix';
import AppoinmentService from "services/Provider/AppoinmentService"
import  FeedbackModal from "../FeedbackModal"
import  StatusModal from "../StatusModal"


const CardItem = ({ history, item, setShouldGetData }) => {
    const appoinmentService = new AppoinmentService()

    const [modalStatus, setModalStatus] = useState(false)
    const [feedbackModal, setFeedbackModal] = useState(false)
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggle = () => setDropdownOpen(prevState => !prevState);
    const [deleteModal, setDeleteModal] = useState(false);

    const handleCloseModal = (action) => {
        setDeleteModal(false);
        if (action === "delete") { 
            setShouldGetData(true)
        }
    };
    return (
        <>
            <tr  >
                <th className="font-size-14">{item.id}</th>
                <th className="font-size-14">{item.title}</th>
                <th className="font-size-14">{item.date.split(' ')[0]}</th>
                <th className="font-size-14">{item.date.split(' ')[1]} {item.date.split(' ')[2]}</th>

                 <th className="font-size-14">{item.type}</th>
                <th className="font-size-14">
                <Badge   className="bgBadge-admin font-size-14 m-0 text-white"
                        style={{ background: getBackGround(item.status) }}>{item.status}</Badge></th>
                <td className="removebtnhover">
                    <Dropdown className="dropdownWidth" color="light" isOpen={dropdownOpen} toggle={toggle}>
                        <DropdownToggle caret>
                            <i className="fa fa-ellipsis-v text-dark fa-lg"></i>
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem onClick={() => history.push(`${providerPrefix}/appoinments/view-appoinment/${item.id}`) }>View</DropdownItem>
                            <DropdownItem onClick={() => history.push(`${providerPrefix}/appoinments/edit-appoinment/${item.id}`) }>Edit</DropdownItem>
                            <DropdownItem onClick={() => setFeedbackModal(true)}>Add Feedback</DropdownItem>
                            <DropdownItem className="text-danger" onClick={() => { setDeleteModal(true) }}>Remove Appoinment</DropdownItem>
                            <hr className="m-0 p-0" />
                            <DropdownItem onClick={() => setModalStatus(true)} style={{color:"#212529"}}>Change Status</DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </td>
            </tr>
            <DeleteModal
                open={deleteModal}
                titleMsg={"Appoinment"}
                deletedItem={item}
                modelService={appoinmentService}
                onCloseModal={(action) => handleCloseModal(action)}
            />
            {modalStatus ? <StatusModal
                modal={modalStatus}
                toggle={() => setModalStatus(!modalStatus)}
                status={item.status}
                id={item.id}
                item={item}
                setShouldGetData={setShouldGetData}
            /> : null}
            {feedbackModal ? <FeedbackModal modal={feedbackModal} id={item.id} toggle={() => setFeedbackModal(!feedbackModal)} />
                : null}
        </>

    );
}
const getBackGround = (status) => {
    return status === "Done" ? "#34e38f"
    : status === "Upcoming" ? "#50a5f1" :"#74788d"
}

export default CardItem;